import React, { Component } from 'react';
import { Wrapper, Container } from './styles';

class Privacy extends Component {
  render() {
    return (
      <Wrapper>
        <Container>
          <h1>Privacy Policy</h1>

          <h2>Key points to note</h2>

          <ul>
            <li>
              We only collect, store and use data which is necessary to provide you with the course you have booked,
              deal with anything relating to the financial transaction, process your exam result and obtain your
              feedback.
            </li>
            <li>
              The data we collect is limited to the data which you input on your online booking, any additional
              information provided in written form on your exam mark sheet, and your financial booking details provided
              at the point of booking.
            </li>
            <li>
              In booking onto one of our courses, you consent to us obtaining the data you provide (which is the data
              you input at point of booking and/or at any of our courses) and consent to us using that data as stated
              within the remainder of this policy. Therefore, our legal basis for obtaining and using your data as
              stated is the consent you provide. Another of our legal basis for obtaining this information is our
              legitimate interest in conducting and managing our business to enable us to give you the best
              service/product. Please see below in our ‘glossary’ section for what this means.
            </li>
            <li>
              It is necessary for us to (securely) share the data we collect with the MDU. Your data which we hold will
              therefore also be subject to the MDU’s privacy policy, and you are advised to read it carefully before you
              agree to share your data with SJT Preparation. It is available here:{' '}
              <a
                href="https://www.themdu.com/privacy"
                title="MDU Privacy Policy"
                target="_blank"
                rel="noreferrer noopener"
              >
                https://www.themdu.com/privacy
              </a>
              .
            </li>
            <li>
              Your data is shared with the MDU to ensure that discounted bookings are legitimately obtained and so that
              the MDU can contact you in relation to your membership status.
            </li>
            <li>
              We will not share your data with third parties for marketing purposes (save and to the extent that the MDU
              may contact you in relation to your membership status).
            </li>
            <li>
              You have the right to request that your data is removed or edited at any time, however if this impacts on
              our ability to continue with your booking we will advise you of this. Please contact us via the contact
              form should you have any request in relation to your data.
            </li>
            <li>
              More detailed information on the above is contained within the remainder of this document, which you are
              strongly advised to read in detail before continuing with your booking.
            </li>
          </ul>

          <h2>What is the purpose of this Privacy Policy?</h2>

          <p>
            SJT Preparation respects your privacy and is committed to protecting your personal data. The aim of this
            Privacy Policy is to give you information on we collect and process your personal data through:
          </p>
          <ol>
            <li>
              your use of the website, including any data you may provide through the website when you make an enquiry
              or purchase a product or any course/programme;
            </li>
            <li>your registration for, purchase of or use of any SJT Preparation products and/or Services;</li>
            <li>your sending of personal data to SJT Preparation by any other means.</li>
          </ol>

          <p>
            This Policy will also inform you of what we do with personal data, how we look after personal data and tell
            you about your privacy rights and how the law protects you. It is important that you read this Privacy
            Policy together with any other privacy policy or fair processing notice we may provide on specific occasions
            when we are collecting or processing personal data about you so that you are fully aware of how and why we
            are using your data. This Privacy Policy supplements the other notices and is not intended to override them.
          </p>

          <h2>Who we are</h2>
          <p>
            The Data Controller for your Data is SJT Preparation. In some circumstances other SJT Preparation affiliated
            companies may carry out activities on its behalf.
          </p>

          <p>
            A number of other Permitted Users will be using your information if, for example, you book the MDU
            discounted rate for the SJT Preparation course. The Permitted Users include the Medical Defence Union
            Limited, which includes the Dental Defence Union (MDU/DDU). However, MDU Services Limited (MDUSL) is the
            nominated representative of MDU/DDU under the Data Protection Act 1998 and MDUSL will be carrying out the
            activities of MDU/DDU for the purposes of this privacy policy. References to 'we' or 'us' include such
            affiliates and Permitted Users.
          </p>

          <h2>Contact Details</h2>
          <p>
            We have appointed a data protection officer (“DPO”) who is responsible for overseeing questions in relation
            to this Privacy Policy. If you have any questions about this Privacy Policy, including any requests to
            exercise your legal rights, please contact the DPO using the following details:
          </p>
          <p>
            FAO of the Data Protection Officer SJT Preparation Limited Windsor House A1 Business Park Long Bennington
            NG23 5JR support@sjtpreparation.co.uk
          </p>

          <p>You have the right to make a complaint at any time to:</p>
          <ul>
            <li>
              the Information Commissioner’s Office (“ICO”), the UK supervisory authority for data protection issues
              (www.ico.org.uk);
            </li>
            <li>
              We would, however, appreciate the chance to deal with your concerns before you approach the ICO (or other
              relevant authority) so please contact us in the first instance.
            </li>
          </ul>

          <h2>Online purchase of courses.</h2>
          <ol>
            <li>
              Credit or debit card details are used for processing payment only. We use Stripe for the processing of
              payments for courses received through this website.
            </li>
            <li>
              When you place an order with us you will receive an automatic confirmation email. Your order represents an
              offer to us to purchase which is accepted upon completion of payment through the online automated system.
              You should receive immediate confirmation of this acceptance by way of a booking confirmation email. If
              you do not receive confirmation, please email support@sjtpreparation.co.uk.
            </li>
            <li>
              While all reasonable care is taken to protect the confidentiality of your card and personal details, SJT
              Preparation cannot be held liable if, through no fault of our own, these details are intercepted and used
              by an unauthorised third party.
            </li>
            <li>
              If you need to cancel a course booking, for whatever reason, you should first contact us by email at
              support@sjtpreparation.co.uk
              <ol>
                <li>
                  In the event that SJT Preparation has to cancel an event due to Covid-19 (or similar) restrictions, we
                  will provide our content online to ensure the same level of service. Our usual refund policy will
                  apply.
                </li>
              </ol>
            </li>
            <li>
              SJT Preparation retain an overall discretion with respect to cancellation and refunds. In most cases SJT
              Preparation will provide a refund on cancelled course bookings up to 30 days before the start date of the
              course.
            </li>
            <li>
              Customers have a right to withdraw from the purchase of a course and obtain a refund within 14 working
              days of the day of order subject to the following:
              <ol>
                <li>
                  This right of withdrawal applies to courses which have been booked more than 30 days prior to the
                  course date.
                </li>
                <li>
                  To cancel a purchase, you must inform SJT Preparation by way of a signed and scanned letter to be sent
                  to support@sjtpreparation.co.uk.
                </li>
                <li>We will refund the price paid within 14 days by the same method as used for payment.</li>
              </ol>
            </li>
            <li>
              MDU discounts must be claimed at the time of booking. No retrospective discounts will be applied upon
              subsequently obtaining MDU graduate membership
            </li>
            <li>All prices include VAT (where applicable). Unless otherwise stated there are no delivery charges.</li>
            <li>
              Any purchase contract is in English and all communication between us must be in English. Nothing in this
              clause is intended to affect your statutory rights.
            </li>
          </ol>

          <h2>Course material and online material</h2>
          <ol>
            <li>
              Neither the Lecturer nor SJT Preparation give any claims, promises, guarantees or warranties about the
              accuracy, completeness, timeliness or adequacy of any information, data, wording or graphics, whether
              written, oral or visual used in connection with this course (Material).
            </li>
            <li>
              All persons using the Material do so at their own risk. Neither SJT Preparation nor the Lecturer will be
              liable for loss or damage arising out of or in connection with the use of the Material. This exclusion of
              liability covers damages of any kind, including (without limitation) compensatory, direct, indirect or
              consequential damages, loss of data, income or profit, loss of or damage to property, claims for third
              parties and losses sustained while attended SJT Preparation events. Notwithstanding the foregoing, none of
              the exclusions and limitations are intended to limit any rights a delegate may have as a consumer or other
              statutory rights which may not be excluded nor in any way to exclude or limit SJT Preparation’s or the
              Lecturer’s liability to the delegate for death or personal injury resulting from SJT Preparation’s or the
              Lecturer’s negligence.
            </li>
            <li>
              All Trade Marks, logos, brand names and service marks of SJT Preparation, whether registered or
              unregistered, remain the property of SJT Preparation, including the terms ‘SJT Preparation’, ‘SJT
              Preparation Course’, ‘SJT Preparation Material’, and any distinctive wording used by SJT Preparation in
              its online and printed material. Any use of these names or marks is prohibited without the express prior
              written consent of SJT Preparation.
            </li>
            <li>
              The Material has been designed as an integral part of the course solely for the benefit of the delegates
              attending the course. No part of the Material may be reproduced in any form or for any purposes without
              the prior permission of SJT Preparation. Any copyright in the Material remains the property of SJT
              Preparation and/or the Lecturer, as applicable.
            </li>
          </ol>

          <h2>Changes to the Privacy Policy and your duty to inform us of changes</h2>
          <p>
            On 25 May 2018 the data protection law in the UK and Channel Islands changed. This Privacy Policy sets out
            your rights under the new laws. It is important that the personal data we hold about you is accurate and
            current. Please keep us informed if your personal data changes during your relationship with us. We may
            update this Privacy Policy from time to time. This version was last updated on 24 May 2018.
          </p>

          <h2>If you reject the terms of this Privacy Policy</h2>
          <p>
            If you do not agree to your personal data being used in accordance with this Privacy Policy, please do not
            submit your personal data to us through the Website or any other means.
          </p>

          <h2>Third-party links</h2>
          <p>
            The Website may include links to third-party websites, plug-ins and applications. Clicking on those links or
            enabling those connections may allow third parties to collect or share data about you. We do not control
            these third-party websites and are not responsible for their privacy policies. When you leave our Website,
            we encourage you to read the privacy policy of every website you visit.
          </p>

          <h2>Your personal data</h2>
          <p>
            Personal data, or personal information, means any information about an individual from which that person can
            be identified. It does not include data where the identity has been removed (anonymous data). We may
            collect, use, store and transfer different kinds of personal data about you which we have grouped together
            as follows:
          </p>
          <ul>
            <li>Contact Data includes billing address, delivery address, postal address, email address.</li>
            <li>Eligibility Data includes education/academic history and / or future plans.</li>
            <li>Financial Data includes bank account, billing information, payment card details</li>
            <li>
              Identity Data includes first name, maiden name, last name, third party reference number, usernames or
              similar identifier title, date of birth and gender.
            </li>
            <li>
              Marketing and Communications Data includes your preferences in receiving marketing from us and your
              communication preferences.
            </li>
            <li>Profile Data includes your usernames and passwords for access to any of our online material.</li>
            <li>
              Other Data includes the course or programme you purchase from SJT Preparation, your test results and any
              other information you may chose to provide beyond that which SJT Preparation requires.
            </li>
            <li>
              Technical Data includes internet protocol (IP) address, your login data, browser type and version, time
              zone setting and location, browser plug-in types and versions, operating system and platform and other
              technology on the devices you use to access this website.
            </li>
            <li>
              Transaction Data includes details about payments to and from you and other details of products and
              services you have purchased from us.
            </li>
            <li>
              Usage Data includes information about your visit to a Website, including the Uniform Resource Locators
              (URL) clickstream to, through and from the Websites (including date and time), products and/or services
              you viewed or searched for, page response times, download errors, lengths of visits to certain pages, page
              interaction information (such as scrolling, clicks and mouseovers) and methods used to browse away from
              the page and any phone number used to call our customer services numbers.
            </li>
          </ul>

          <p>
            We also collect, use and share Aggregated Data such as statistical or demographic data for any purpose.
            Aggregated Data may be derived from your personal data but is not considered personal data in law as this
            data does not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to
            calculate the percentage of users accessing a specific website feature. However, if we combine or connect
            Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the
            combined data as personal data which will be used in accordance with this Privacy Policy.
          </p>

          <h2>How is your personal data collected?</h2>

          <p>We collect your personal data through our online form, or through input on exam papers.</p>

          <p>This includes personal data you provide when you:</p>
          <ul>
            <li>a. apply for a course;</li>
            <li>b. submit an online query;</li>
            <li>c. purchase goods or Services from us;</li>
          </ul>

          <h2>How we use your personal data</h2>

          <p>
            We will only use your personal data when the law allows us to. Most commonly, we will use your personal data
            in the following circumstances:
          </p>
          <ul>
            <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
            <li>
              Where it is necessary for our legitimate interests (or those of a third party) and your interests and
              fundamental rights do not override those interests.
            </li>
            <li>Where we need to comply with a legal or regulatory obligation.</li>
            <li>Where we have your consent.</li>
          </ul>

          <p>
            Where we are relying on your consent as a legal basis for processing your personal data, you may withdraw
            your consent to this processing at any time by contacting us.
          </p>

          <h2>Purposes for which we will use your personal data</h2>

          <p>
            We have set out below a description of all the ways we plan to use your personal data, and which legal basis
            we rely on to do so. We have also identified what our legitimate interests are where appropriate. Note that
            we may process your personal data for more than one lawful ground depending on the specific purpose for
            which we are using your data. Please contact us if you need details about the specific legal ground we are
            relying on to process your personal data where more than one ground has been set out in the table below.
            Please be aware that in the majority of cases we will have a contract in place with you in respect of the
            course or programme you are undertaking. Therefore, our lawful basis for processing your personal data will
            be to perform our contract with you.
          </p>

          <h3>Lawful Basis</h3>
          <ul>
            <li>Performance of a contract with you (A)</li>
            <li>Consent (B)</li>
            <li>
              Necessary for our legitimate interests of delivering course material, studying how persons use our website
              and course content and services to develop them and grow the business (C)
            </li>
            <li>To comply with legal obligations (D)</li>
          </ul>

          <h3>Purpose / activity</h3>
          <ol>
            <li>To respond to queries or requests for information (A,B,C,D)</li>
            <li>to register you for a course (A,B,C)</li>
            <li>to deliver the course programme (A,B,C,D)</li>
            <li>
              to manage your payment and/or deal with refund requests and/or to keep records for accounting purposes
              (A,B,C,D)
            </li>
            <li>to defend any claims brought against SJT Preparation Limited (A,D)</li>
            <li>to register you as a new customer (A,B,C)</li>
            <li>to process your order (A,B,C)</li>
            <li>to manage our relationship with you (A,B,C)</li>
            <li>to enable you to participate in a survey or prize-draw (B,C)</li>
            <li>to administer and protect our website (C)</li>
            <li>to deliver relevant website content (C)</li>
            <li>to use data to improve our website content (C)</li>
          </ol>

          <h3>Type of data</h3>

          <p>
            The number of the activity / purpose that each type of data below may be used in relation to is as follows:
          </p>

          <p>Contact – 1,2,3,4,5,6,7,8,9,10,11,12</p>
          <p>Identity - 1,2,3,4,5,6,7,8,9,10,11,12</p>
          <p>Profile - 1,2,3,4,5,6,7,8,9,10,11,12</p>
          <p>Transaction - 1,2,3,4,5,6,7,8,9,10,11,12</p>
          <p>Financial - 1,2,3,4,5,6,7,8,9,10,11,12</p>
          <p>Marketing and communications - 1,2,3,5,6,7,8,9,10,11,12</p>

          <h2>Promotional offers from us</h2>
          <p>
            We may use your Identity, Contact, Technical, Usage and Profile Data to form a view on what we think you may
            want or need, or what may be of interest to you. This is how we decide which products, Services and offers
            may be relevant for you (we call this marketing). You will receive marketing communications from us if you
            have requested information from us or purchased goods or Services from us or if you provided us with your
            details when you entered a competition or registered for a promotion and, in each case, you have not opted
            out of receiving that marketing.
          </p>

          <h2>Third-party marketing</h2>
          <p>We will get your express opt-in consent before we share your personal data with any company.</p>

          <h2>Opting out</h2>
          <p>You can ask us to stop sending you marketing messages at any time by emailing us via the consent form.</p>

          <h2>Cookies</h2>
          <p>
            You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access
            cookies. If you disable or refuse cookies, please note that some parts of this website may become
            inaccessible or not function properly
          </p>

          <h2>Change of purpose</h2>
          <p>
            We will only use your personal data for the purposes for which we collected it, unless we reasonably
            consider that we need to use it for another reason and that reason is compatible with the original purpose.
            If you wish to get an explanation as to how the processing for the new purpose is compatible with the
            original purpose, please contact us. If we need to use your personal data for an unrelated purpose, we will
            notify you and we will explain the legal basis which allows us to do so. Please note that we may process
            your personal data without your knowledge or consent, in compliance with the above rules, where this is
            required or permitted by law.
          </p>

          <h2>Disclosures of your personal data</h2>

          <p>We may have to share your personal data with the parties set out below</p>
          <ul>
            <li>
              External venues where some element of a course or programme (or event) is delivered (SJT Preparation may
              share Identity Data with the venue for registration and health and safety purposes).
            </li>
            <li>
              Third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets.
              Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our
              business, then the new owners may use your personal data in the same way as set out in this Privacy
              Policy.
            </li>
            <li>
              We require all third parties to respect the security of your personal data and to treat it in accordance
              with the law. We do not allow our third-party service providers to use your personal data for their own
              purposes and only permit them to process your personal data for specified purposes and in accordance with
              our instructions.
            </li>
          </ul>

          <h2>Data Security</h2>
          <p>
            We have put in place appropriate security measures to prevent your personal data from being accidentally
            lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your
            personal data to those employees, agents, contractors and other third parties who have a business need to
            know. They will only process your personal data on our instructions and they are subject to a duty of
            confidentiality. We have put in place procedures to deal with any suspected personal data breach and will
            notify you and any applicable regulator of a breach where we are legally required to do so. Your personal
            data may be held on by SJT Preparation on an encrypted laptop or secure server and/or on the IT system of
            another third party company which is providing IT hosting or other data processing services, in accordance
            with SJT Preparation’s arrangement in place with that company. All information that you provide to us is
            stored on secure servers. Any payment transactions will be encrypted using SSL technology. Where we have
            given you (or where you have chosen) a password which enables you to access certain parts of the Websites,
            you are responsible for keeping this password confidential. We ask you not to share a password with anyone.
          </p>

          <h2>Data retention</h2>
          <p>
            We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for,
            including for the purposes of satisfying any legal, accounting, or reporting requirements. To determine the
            appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the
            personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the
            purposes for which we process your personal data and whether we can achieve those purposes through other
            means, and the applicable legal requirements. We will not hold any data for longer than 7 years. Should you
            wish for your data to be deleted prior the the expiry of 7 years, please contact us via the contact form.
          </p>

          <h2>Your legal rights</h2>
          <p>
            Under certain circumstances, you have rights under data protection laws in relation to your personal data:-
          </p>

          <p>You have the right to:</p>
          <ul>
            <li>
              Request access to your personal data (commonly known as a “data subject access request”). This enables you
              to receive a copy of the personal data we hold about you and to check that we are lawfully processing it.
            </li>
            <li>
              Request correction of the personal data that we hold about you. This enables you to have any incomplete or
              inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data you
              provide to us. Please be aware that this right does not apply to exam scripts or exam marks.
            </li>
            <li>
              Request erasure of your personal data. This enables you to ask us to delete or remove personal data where
              there is no good reason for us continuing to process it. You also have the right to ask us to delete or
              remove your personal data where you have successfully exercised your right to object to processing (see
              below), where we may have processed your information unlawfully or where we are required to erase your
              personal data to comply with local law. Note, however, that we may not always be able to comply with your
              request of erasure for specific legal reasons which will be notified to you, if applicable, at the time of
              your request. Please be aware that this right does not apply to exam scripts or exam marks.
            </li>
            <li>
              Object to processing of your personal data where we are relying on a legitimate interest (or those of a
              third party) and there is something about your particular situation which makes you want to object to
              processing on this ground as you feel it impacts on your fundamental rights and freedoms.
            </li>
            <li>
              You also have the right to object where we are processing your personal data for direct marketing
              purposes. In some cases, we may demonstrate that we have compelling legitimate grounds to process your
              information which override your rights and freedoms. Please be aware that this right does not apply to
              exam scripts or exam marks.
            </li>
            <li>
              Request restriction of processing of your personal data. This enables you to ask us to suspend the
              processing of your personal data in the following scenarios: (a) if you want us to establish the data’s
              accuracy; (b) where our use of the data is unlawful but you do not want us to erase it; (c) where you need
              us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal
              claims; or (d) you have objected to our use of your data but we need to verify whether we have overriding
              legitimate grounds to use it. Please be aware that this right does not apply to exam scripts or exam
              marks.
            </li>
            <li>
              Request the transfer of your personal data to you or to a third party. We will provide to you, or a third
              party you have chosen, your personal data in a structured, commonly used, machine-readable format. Note
              that this right only applies to automated information which you initially provided consent for us to use
              or where we used the information to perform a contract with you.
            </li>
            <li>
              Withdraw consent at any time where we are relying on consent to process your personal data. However, this
              will not affect the lawfulness of any processing carried out before you withdraw your consent. If you
              withdraw your consent, we may not be able to provide certain services to you. We will advise you if this
              is the case at the time you withdraw your consent
            </li>
          </ul>

          <h2>No fee usually required</h2>
          <p>
            You will not have to pay a fee to access your personal data (or to exercise any of the other rights).
            However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive.
            Alternatively, we may refuse to comply with your request in these circumstances.
          </p>

          <h2>What we may need from you</h2>
          <p>
            We may need to request specific information from you to help us confirm your identity and ensure your right
            to access your personal data (or to exercise any of your other rights). This is a security measure to ensure
            that personal data is not disclosed to any person who has no right to receive it. We may also contact you to
            ask you for further information in relation to your request to speed up our response.
          </p>

          <h2>Time limit to respond</h2>
          <p>
            We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a
            month if your request is particularly complex or you have made a number of requests. In this case, we will
            notify you and keep you updated.
          </p>

          <h2>Glossary</h2>

          <p>
            Legitimate Interest means the interest of our business in conducting and managing our business to enable us
            to give you the best service/product and the best and most secure experience. We make sure we consider and
            balance any potential impact on you (both positive and negative) and your rights before we process your
            personal data for our legitimate interests. We do not use your personal data for activities where our
            interests are overridden by the impact on you (unless we have your consent or are otherwise required or
            permitted to by law). You can obtain further information about how we assess our legitimate interests
            against any potential impact on you in respect of specific activities by contacting us.
          </p>

          <p>
            Performance of Contract means processing your data where it is necessary for the performance of a contract
            to which you are a party or to take steps at your request before entering into such a contract.
          </p>

          <p>
            Comply with a legal or regulatory obligation means processing your personal data where it is necessary for
            compliance with a legal or regulatory obligation that we are subject to.
          </p>

          <p>Third parties</p>
          <p>
            We are currently only engaged with the MDU and exam markers, and as such any reference to third party
            relates only to the same.
          </p>
        </Container>
      </Wrapper>
    );
  }
}

export default Privacy;
